import React from 'react';
import { Button } from './button';

const CollapseExpandButton = ({
  isExpanded,
  onClick,
  className = "",
  disabled = false
}) => {
  return (
    <Button
      variant="ghost"
      size="sm"
      className={`w-7 h-7 p-1 text-muted-foreground hover:text-foreground hover:bg-muted transition-all duration-200 ${className}`}
      onClick={onClick}
      disabled={disabled}
      aria-label={isExpanded ? 'Collapse section' : 'Expand section'}
      title={isExpanded ? 'Collapse section' : 'Expand section'}
    >
      <span className="text-lg font-bold leading-none select-none">
        {isExpanded ? '−' : '+'}
      </span>
    </Button>
  );
};

export default CollapseExpandButton;